import { Stack, Typography } from '@mui/material';

import { CarouselProduct } from '@app/components/Company/CarouselProduct';
import { CustomSelectArea } from '@app/components/Company/CustomSelectArea';
import { LoadingSpinner } from '@app/components/Shared/LoadingSpinner';
import { theme } from '@app/theme';
import { Product } from '@app/types/catalog';

interface ProductShowingListProps {
  isFetching: boolean;
  isProperty?: boolean;
  products: Product[];
  selectedPrefecture: string[];
  setPrefecture: React.Dispatch<React.SetStateAction<string[]>>;
}
export const ProductShowingList = ({
  products,
  isFetching,
  selectedPrefecture,
  setPrefecture,
  isProperty,
}: ProductShowingListProps) => {
  return (
    <>
      <Stack
        px={{
          sm: 1,
          xs: 2.5,
        }}
      >
        <Typography
          maxWidth={1000}
          color="white"
          align="center"
          paddingY={1}
          width="100%"
          mx="auto"
          marginTop={6}
          borderRadius={50}
          bgcolor="#3287E1"
          sx={{
            fontSize: 'clamp(1.375rem, 1.3068rem + 0.28vw, 1.5rem)',
            fontWeight: 700,
          }}
        >
          {isProperty ? '分譲住宅一覧' : '住宅展示場一覧'}
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          marginY={5}
          spacing={2}
        >
          <Typography
            align="center"
            textAlign="center"
            fontWeight={600}
            lineHeight={1.5}
            color="#718CA0"
          >
            エリア
          </Typography>
          <CustomSelectArea
            selectedPrefecture={selectedPrefecture}
            setPrefecture={setPrefecture}
          />
        </Stack>
      </Stack>
      {isFetching ? (
        <LoadingSpinner sx={{ height: 300 }} />
      ) : (
        <Stack minHeight={300} mt={3} justifyContent="center">
          {products?.length ? (
            <CarouselProduct products={products} isProperty={isProperty} />
          ) : (
            <Typography
              variant="body1"
              textAlign="center"
              width="100%"
              color={theme.palette.text.secondary}
            >
              {isProperty ? '物件なし' : '展示場なし'}
            </Typography>
          )}
        </Stack>
      )}
    </>
  );
};
